<script setup lang="ts">
/**
 * PlaybackControlsOverlay
 *
 * Schwebende Abspielleiste über der Partitur: oben rechts angedockt, beim Abspielen folgt sie dem
 * Playback-Cursor vertikal. Nur mit Player-Kontext (Eingabe-Vorschau) – auf der Griffschrift-
 * Ausgabe gibt es keinen Player (`injectScorePlayback(null)`, siehe `playbackContext.ts`), dort
 * rendert die Komponente nichts.
 */
import {computed} from 'vue';
import {computedWithControl} from '@vueuse/core';
import {storeToRefs} from 'pinia';

import OsmdPlaybackControls from './OsmdPlaybackControls.vue';
import {injectScoreEditContext} from './editContext';
import {injectScorePlayback} from './playbackContext';
import {usePlaybackStore} from '@/stores/playbackStore';

const {getOsmd} = injectScoreEditContext();
const playback = injectScorePlayback(null);
const isPlaying = computed(() => playback?.isPlaying.value ?? false);

// Cursor-Höhe nur bei Taktwechsel neu lesen (das DOM-Element ist nicht reaktiv).
const {playbackMeasureIndex} = storeToRefs(usePlaybackStore());
const cursorPositionTop = computedWithControl(playbackMeasureIndex, () =>
    getOsmd()?.cursor?.cursorElement?.style?.top ?? '0px');
const playbackPanelTop = computed(() => (isPlaying.value ? cursorPositionTop.value : '0'));
</script>

<template>
  <!-- Volle Fläche über der Partitur, selbst ohne Pointer-Events: Klicks fallen zur Partitur durch,
       nur die Leiste ist interaktiv. -->
  <div v-if="playback" class="pointer-events-none absolute inset-0 z-20">
    <OsmdPlaybackControls
        class="pointer-events-auto absolute right-2 h-8 transition-all duration-300"
        :style="{ top: playbackPanelTop }"
        :class="{'border-green-400/80': isPlaying}"
    />
  </div>
</template>
